import {
  mdiAccount,
  mdiAccountCircle,
  mdiAccountCog,
  mdiAccountGroup,
  mdiAccountGroupOutline,
  mdiAccountTie,
  mdiAlert,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiArrowLeft,
  mdiArrowSplitHorizontal,
  mdiArrowSplitVertical,
  mdiAutoFix,
  mdiBellCheck,
  mdiBook,
  mdiCalendarClock,
  mdiChartBar,
  mdiChartBox,
  mdiChartDonut,
  mdiChartLine,
  mdiChartTimelineVariant,
  mdiCheckCircle,
  mdiChevronDown,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircle,
  mdiClock,
  mdiClockOutline,
  mdiClose,
  mdiCloudArrowUp,
  mdiCodeBraces,
  mdiContentCopy,
  mdiContentSave,
  mdiConsole,
  mdiCounter,
  mdiCurrencyInr,
  mdiDelete,
  mdiDipSwitch,
  mdiDomain,
  mdiDotsVertical,
  mdiEmail,
  mdiEye,
  mdiFire,
  mdiFileAlertOutline,
  mdiFileDocument,
  mdiFilePdfBox,
  mdiFileQuestionOutline,
  mdiFileSearchOutline,
  mdiFinance,
  mdiFormatText,
  mdiFrequentlyAskedQuestions,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiGoogle,
  mdiHelpCircle,
  mdiHome,
  mdiInformationOutline,
  mdiLightbulbAlert,
  mdiLightbulbAlertOutline,
  mdiLightbulbOnOutline,
  mdiLightningBolt,
  mdiLinkBoxVariant,
  mdiLinkVariant,
  mdiLogout,
  mdiMagnify,
  mdiMessageTextOutline,
  mdiMonitorDashboard,
  mdiLogin,
  mdiOpenInNew,
  mdiPencil,
  mdiPlay,
  mdiPlaylistCheck,
  mdiPlus,
  mdiRefresh,
  mdiRobot,
  mdiScaleBalance,
  mdiShieldCheck,
  mdiShieldStarOutline,
  mdiStrategy,
  mdiSend,
  mdiSync,
  mdiTargetAccount,
  mdiTextBoxOutline,
  mdiTimeline,
  mdiTools,
  mdiTrendingUp,
  mdiTrendingDown,
  mdiTriangle,
  mdiTriangleDown,
  mdiUpload,
  mdiVectorDifference,
  mdiWallet,
  mdiWeb,
  mdiWhatsapp,
  
  
    
  
} from '@mdi/js';
import { mdi } from 'vuetify/iconsets/mdi-svg';

export const customMdiIcons = {
  mdiAccount,
  mdiAccountCircle,
  mdiAccountCog,
  mdiAccountGroup,
  mdiAccountGroupOutline,
  mdiAccountTie,
  mdiAlert,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiArrowLeft,
  mdiArrowSplitHorizontal,
  mdiArrowSplitVertical,
  mdiAutoFix,
  mdiBellCheck,
  mdiBook,
  mdiCalendarClock,
  mdiChartBar,
  mdiChartBox,
  mdiChartDonut,
  mdiChartLine,
  mdiChartTimelineVariant,
  mdiCheckCircle,
  mdiChevronDown,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircle,
  mdiClock,
  mdiClockOutline,
  mdiClose,
  mdiCloudArrowUp,
  mdiCodeBraces,
  mdiContentCopy,
  mdiContentSave,
  mdiConsole,
  mdiCounter,
  mdiCurrencyInr,
  mdiDelete,
  mdiDipSwitch,
  mdiDomain,
  mdiDotsVertical,
  mdiEmail,
  mdiEye,
  mdiFire,
  mdiFileAlertOutline,
  mdiFileDocument,
  mdiFilePdfBox,
  mdiFileQuestionOutline,
  mdiFileSearchOutline,
  mdiFinance,
  mdiFormatText,
  mdiFrequentlyAskedQuestions,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiGoogle,
  mdiHelpCircle,
  mdiHome,
  mdiInformationOutline,
  mdiLightbulbAlert,
  mdiLightbulbAlertOutline,
  mdiLightbulbOnOutline,
  mdiLightningBolt,
  mdiLinkBoxVariant,
  mdiLinkVariant,
  mdiLogin,
  mdiLogout,
  mdiMagnify,
  mdiMessageTextOutline,
  mdiMonitorDashboard,
  mdiOpenInNew,
  mdiPencil,
  mdiPlay,
  mdiPlaylistCheck,
  mdiPlus,
  mdiRefresh,
  mdiRobot,
  mdiScaleBalance,
  mdiShieldCheck,
  mdiShieldStarOutline,
  mdiStrategy,
  mdiSend,
  mdiSync,
  mdiTargetAccount,
  mdiTextBoxOutline,
  mdiTimeline,
  mdiTools,
  mdiTrendingUp,
  mdiTrendingDown,
  mdiTriangle,
  mdiTriangleDown,
  mdiUpload,
  mdiWallet,
  mdiVectorDifference,
  mdiWeb,
  mdiWhatsapp,
};